var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.loading.completed)?_c('div',{attrs:{"id":"footer"}},[_c('p',[_vm._v("resn 2018 or whatever")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }